import { snackbarService } from "~/components/SnackbarStack";

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

export async function downloadBlob(blob: Blob, filename: string) {
  const isMobileOS = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // Integração com Aplicativo Nativo (Expo/React Native)
  if (window.ReactNativeWebView) {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result as string; 
      // Remove o prefixo (e.g. "data:application/pdf;base64,") para deixar apenas a string em base64
      const base64Content = base64data.split(',')[1] || '';
      
      // Envia uma mensagem interceptável pro WebView no Expo abrir o Menu de Compartilhamento Nativo (UI limpa)
      window.ReactNativeWebView?.postMessage(JSON.stringify({
         type: 'DOWNLOAD_BLOB',
         payload: {
            filename: filename,
            mimeType: blob.type || 'application/pdf',
            base64: base64Content
         }
      }));
    };
    return; // Responsabilidade repassada ao Expo.
  }

  // Tentativa de usar a API de Compartilhamento Nativo (Web Share API) no Mobile/WebView
  if (isMobileOS && navigator.share && navigator.canShare) {
    try {
      const file = new File([blob], filename, { type: blob.type || "application/pdf" });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: filename,
        });
        return; // O usuário interagiu com a UI nativa (abrir, salvar, compartilhar)
      }
    } catch (error) {
      console.warn("Native file sharing failed", error);
    }
  }

  // Fallback padrão para web
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;

  if (isMobileOS) {
    link.target = "_blank"; // No mobile/WebView força a abertura no visualizador interno ou navegador
    // Em alguns WebViews, omitir o attributo download permite que o navegador saiba que deve tentar exibir, não apenas baixar o arquivo silenciosamente
    
    // Feedback visual importante para Android WebViews que forçam o silencioso download:
    snackbarService.showSnackbar(
      "Download iniciado! Verifique as notificações de download do seu celular.",
      "success"
    );
  } else {
    link.download = filename; // Comportamento padrão de download no Desktop
  }

  link.click();

  // O timeout longo é importante para mobile webviews processarem a navegação da URL antes de revoga-la
  setTimeout(() => {
    link.parentNode?.removeChild(link);
    URL.revokeObjectURL(url);
  }, 1000);
}
